import React, { Component, Fragment } from "react";
import Breadcrumbs from "../../shared/Breadcrumbs";
import { CategoryRoute } from "../../routing/IndividualRoutes";

export class CategoryPage extends Component {
  render() {
    return (
      <Fragment>
        <Breadcrumbs />
        <CategoryRoute />
      </Fragment>
    );
  }
}
